<div class="footer">
  <div class="live" *ngIf="showFull">
    <div class="logo">
      <div class="image"></div>
      <div class="name">
        <div class="name-1">ACTU</div>
        <div class="name-2">LIVE</div>
      </div>
    </div>
    <div class="news">
      The Port of Hong Kong recorded its biggest increase in activity since October 2017 - Vietnam, business destination
      for all entrepreneurs - The port of Hong Kong record
    </div>
  </div>
  <div class="d-flex align-items-center" [class.show-full]="showFull">
    <ul class="menu-item">
      <li *ngIf="isLogin"><a (click)="goToFaq()" target="_blank">{{'FAQs' | translate}}</a></li>
      <li *ngFor="let footer of footers"><a (click)="actionFooter(footer.value)" target="_blank">{{footer.label}}</a></li>
      <li>®2020 Logchain</li>
      <li style="text-transform: ita;"><i>{{appVersion}}</i></li>
    </ul>
  </div>
</div>
